import React from 'react';
import ArticleField from '../ArticleField';
import StrapiSearch from '../StrapiSearch';

interface SecondaryThemesProps {
    value: any[],
    onChange: (value: any[]) => void
}

const SecondaryThemes = (props: SecondaryThemesProps) => (
    <ArticleField label="Thèmes secondaires">
        <StrapiSearch
            multiple
            collection="themes"
            search_attribute="name"
            value={props.value}
            onChange={props.onChange} />
    </ArticleField>
)

export default SecondaryThemes;